(function () {
  const initAnnSlider = (section) => {
    if (!section || !section.classList.contains('section-announcement')) return;

    const slider = section.querySelector('.announcement-bar--swiper');
    

    if (!slider) return;
    const slideCount = slider.querySelectorAll('.swiper-slide').length;
    const rowsMobile = Number(slider.dataset.rowsMobile) || 1;
    const rowsDesktop = Number(slider.dataset.rows) || 1;

    const swiperParams = {
      speed: Number(slider.dataset.speed) || 800,
      //speed:800,
      direction: 'horizontal',
      spaceBetween: 0,
      slidesPerView: rowsMobile,
      //autoHeight: true,
       effect: 'fade',
      //loop: true,
      navigation: {
  nextEl: slider.querySelector('.announcement-bar__arrow--next'),
  prevEl: slider.querySelector('.announcement-bar__arrow--prev')
},
//autoplay:false,
autoplay:
        slideCount > rowsMobile
          ? {
              enabled: true,
              delay: Number(slider.dataset.delay) || 2000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }
          : { enabled: false },
      breakpoints: {
        765: {
          slidesPerView: rowsDesktop,
          autoplay:
            slideCount > rowsDesktop
              ? {
                  enabled: true,
                  delay: Number(slider.dataset.delay) || 2000,
                  pauseOnMouseEnter: true,
                  disableOnInteraction: false,
                }
              : { enabled: false },
        },
      },

    };

    new Swiper(slider, swiperParams);
  };

  initAnnSlider(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', function (event) {
    initAnnSlider(event.target);
  });
})();

